import React, { useMemo, useContext } from 'react';
import ContactForm from 'commonComponents/forms/ContactForm/ContactForm';
import withContactForm, { FormContext } from 'hocHelpers/withContactForm';
import { MessageField } from 'commonComponents/forms/specialFields/specialFields.jsx';
import styles from './FormBoxSection.module.scss';

const FormBoxSection = ({ sideBar, specificFields, ...props }) => {
  const { responseOk } = useContext(FormContext);
  const sideBarElement = useMemo(() => sideBar && sideBar(!responseOk), [responseOk, sideBar]);
  const { notes } = props.fields;

  const specificFieldsElements = (
    <>
      { specificFields }
      { notes && <MessageField name='notes' { ...notes } /> }
    </>
  );

  const contactFormProps = {
    ...props,
    specificFields: specificFieldsElements,
    sideBar: sideBarElement
  };

  return (
    <div className={ styles.FormBoxSection }>
      <div className={ styles.content }>
        { !responseOk && <h2 className={ styles.formHeader }>
          { props.title }
        </h2> }
        <ContactForm { ...contactFormProps } />
      </div>
    </div>
  );
};

export default withContactForm(FormBoxSection);
